/* unplugin-vue-components disabled */

export default {
  mixins: [ModelValue(String)],
  props: {
    options: {type: Array, required: true}
  }
}
